import _ from 'lodash'
import store from '../stores/configureStore'

export function getSessionDataPayload() {
  const typedRecipient = _.get(store.getState(), 'recipient.typedRecipient', '')
  const hasSeenNote = _.get(store.getState(), 'transaction.hasSeenNote', false)
  return { typedRecipient, hasSeenNote }
}
